export const tableColumns: any[] = [
  {
    title: '模块',
    dataIndex: 'moduleInfo',
    align: 'left',
    width: 150,
    ellipsis: true,
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    width: 30,
    ellipsis: true,
  },
  {
    title: '持续时间',
    dataIndex: 'duration',
    align: 'left',
    width: 50,
    ellipsis: true,
  },
  {
    title: '负责人',
    dataIndex: 'principal',
    align: 'left',
    width: 60,
    ellipsis: true,
  },
  {
    title: '日志详情',
    dataIndex: 'logDetails',
    align: 'left',
    width: 150,
    ellipsis: true,
  },
];
